import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

export enum AddProviderFormField {
  providerName = 'providerName',
}

export interface AddProviderForm {
  [AddProviderFormField.providerName]: string;
}

interface Props {
  isViewMode?: boolean;
}

const useAddProviderForm = ({ isViewMode = false }: Props = {}) => {
  const validationSchema = isViewMode ? {} : {
    [AddProviderFormField.providerName]: VALIDATORS.REQUIRED_STRING,
  };

  const methods = useForm<AddProviderForm>({
    resolver: getValidationResolver(validationSchema)
  });

  return { methods };
};

export default useAddProviderForm;
